let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1BjZP")).then(() => parcelRequire('4Giid'));